module.exports = __webpack_public_path__ + "static/media/sine-explorer-detail.23bdcc84.png";